var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"query-base-card"},[_c(_vm.componentMapping[_vm.deType],_vm._b({tag:"component"},'component',_vm.$options.propsData,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }